import { type ValorIpgConfig } from './valor-backend-config.types';
import { ValorRpaModuleName } from './valor-rpa-module-names';
import { ValorIpgConfigurationMode, ValorIpgSystemId } from './valor-system-constants';

export const ValorIpgConfigDemo: ValorIpgConfig = {
    ipg_id: ValorIpgSystemId,
    configuration_mode: ValorIpgConfigurationMode.DEMO,
    name: 'Valor',
    urlPattern: 'https://*.valorpaytech.com/*',
    workflow_prefix: 'valor',
    allowedWebsites: [
        {
            type: 'ipg',
            system_id: ValorIpgSystemId,
            url: 'https://demo.valorpaytech.com',
            name: 'Valor Portal (Demo)',
            allowedUrlPatterns: ['https://*.valorpaytech.com/*'],
            sessionPersistence: 'persistent',
            promoteSessionCookies: false,
            urlPatternsRules: [],
            fetchDefaultAction: 'allow',
            iframeUrlPatterns: [],
            iframeDefaultAction: 'allow',
        },
    ],
    rpaModules: [ValorRpaModuleName.VALORPAYTECH_IPG],
    default_api_url: 'https://securelink-staging.valorpaytech.com:4430',
    default_channel: '3544e7efd37def83b47c01c82f3241a0',
};

export const ValorIpgConfigProd: ValorIpgConfig = {
    ipg_id: ValorIpgSystemId,
    configuration_mode: ValorIpgConfigurationMode.PRODUCTION,
    name: 'Valor',
    urlPattern: 'https://*.valorpaytech.com/*',
    workflow_prefix: 'valor',
    allowedWebsites: [
        {
            type: 'ipg',
            system_id: ValorIpgSystemId,
            url: 'https://online.valorpaytech.com',
            name: 'Valor Portal',
            allowedUrlPatterns: ['https://*.valorpaytech.com/*'],
            sessionPersistence: 'persistent',
            promoteSessionCookies: false,
            urlPatternsRules: [],
            fetchDefaultAction: 'allow',
            iframeUrlPatterns: [],
            iframeDefaultAction: 'allow',
        },
    ],
    rpaModules: [ValorRpaModuleName.VALORPAYTECH_IPG],
    default_api_url: 'https://securelink.valorpaytech.com',
    default_channel: '57478182a981f8c43b84e5c651e5fdf4',
};
